import superagent from 'superagent';
import webservice from './webservice';
import getCookie from './getCookie';

export default async function GetConsumirTerraVoucher(usuarioOk, voucher) {
  const url = `${webservice}/GetConsumirTerraVoucher?usuarioOk=${usuarioOk}&kit=${usuarioOk}&CodigoTerrVoucher=${voucher}`;
  let response = {};

  await superagent
    .get(url)
    .auth(getCookie('TMBcartToken'), { type: 'bearer' })
    .then((res) => {
      response = res.body.GetConsumirTerraVoucherResult;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        typeMessage: 'error',
        message: 'Error',
      };
      response = resp;
    });

  return response;
}
